import styled from "styled-components"
import { device } from "breakpoints"
import { getSolidColor } from "helpers/getSolidColor"
import { getGradient } from "helpers/getGradient"
import { getGradientText } from "helpers/getGradientText"
import { Button } from "../Button"
import { Icon, Label } from "../Button/style"

export const InternalNavContainer = styled.div`
  width: 100%;
  box-shadow: 0 15px 25px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;

  @media ${device.desktop} {
    background-color: #fff;
  }
`

export const TitleWrapper = styled.div`
  padding: 22px 28px;
  display: flex;
  align-items: center;
  font-size: 16px;
  background: ${props => getGradient(props.theme.site)};
  position: relative;

  @media ${device.desktop} {
    font-size: 20px;
    padding: 30px 28px;
  }

  h3 {
    font-size: inherit;
    color: white;
  }
`
export const Nav = styled.nav``
export const PrimaryList = styled.ul`
  list-style-type: none;
`

export const Clickables = styled(TitleWrapper)`
  padding: 0;
  background: ${props => (props.expanded ? "none" : "#f6f8fa")};
  justify-content: space-between;
  border-bottom: ${props =>
    props.expanded ? "1px solid transparent" : "1px solid #EBECF4"};

  padding-top: 20px;
  padding-bottom: 20px;

  @media ${device.desktop} {
    padding: 21px 28px;
  }
  a {
    font-weight: 600;
    ${props => props.expanded && getGradientText(props.theme.site)};
    padding-left: 30px;

    @media ${device.desktop} {
      font-size: 18px;
    }
  }
`
export const PrimaryItem = styled.li`
  width: 100%;
  svg {
    path {
      fill: black;
    }
  }
`

export const SecondaryList = styled.ul`
  display: ${props => (props.expanded ? "flex" : "none")};
  flex-direction: column;
  margin-left: 50px;
  list-style-type: none;
  padding-bottom: 23px;
  margin-top: -12px;
`

export const NavItemButton = styled(Button)`
  /* outline: none; */
  background: none;
  border: none;
  height: 100%;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  padding-right: 30px;
  padding-left: 30px;
  color: #000;

  @media ${device.desktop} {
    padding-left: 5px;
    padding-right: 0;
  }

  :before {
    content: "";
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  ${Label} {
    font-weight: 600;
    font-size: 16px;
    color: #565762;
    letter-spacing: -0.12px;
    line-height: 24px;
    text-align: left;
    ${props => props.expanded && getGradientText(props.theme.site)};

    @media ${device.desktop} {
      font-size: 18px;
      letter-spacing: -0.14px;
      line-height: 27px;
    }
  }
  ${Icon} {
    height: 12px;
    width: 7px;
    transform: rotate(90deg);
    transform: ${props => props.expanded && "rotate(90deg) scale(-1)"};
    opacity: ${props => (props.expanded ? 0.2 : 1)};
    margin-right: 0;
    margin-left: auto;
  }
`
export const SecondaryItem = styled.li`
  font-weight: 600;
  font-size: 14px;
  color: #565762;
  padding: 9px 0;
  transition: 90ms;
  position: relative;

  @media ${device.desktop} {
    font-size: 16px;
    z-index: 2;
  }

  ::after {
    content: "";
    height: 6px;
    width: 6px;
    background-color: ${props => getSolidColor(props.theme.site)};
    display: block;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -18px;
    transition: 90ms;

    @media ${device.desktop} {
      /* top: 12px;
      font-size: 20px;
      left: -30px; */
    }
  }

  :before {
    content: "";
    position: absolute;
    top: 50%;
    left: -36px;
    transform: translate3d(0, -50%, 0);
    width: calc(100% + 36px - 15px);
    height: 90%;
    background: ${props => getGradient(props.theme.site)};
    border-radius: 24px;
    z-index: -1;
    opacity: 0;
    transition: 90ms;
  }

  :hover {
    color: white;
    :after {
      background-color: white;
    }
    :before {
      opacity: 1;
    }
  }

  a:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`
